export const env = {
  get isProduction() {
    return this.environment === 'production';
  },

  get isDevelopment() {
    return this.environment === 'development';
  },

  environment: import.meta.env.VITE_NODE_ENV || 'development',
  recaptcha: {
    v2SiteKey: import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY,
    v3SiteKey: import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY,
    smmV2SiteKey: import.meta.env.VITE_SMM_RECAPTCHA_V2_SITE_KEY,
    smmV3SiteKey: import.meta.env.VITE_SMM_RECAPTCHA_V3_SITE_KEY,
  },

  fusionAuth: {
    authority: import.meta.env.VITE_FUSIONAUTH_AUTHORITY,
    clientId: import.meta.env.VITE_FUSIONAUTH_GEARBELT_CLIENT_ID,
  },

  segment: {
    writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
    debug: import.meta.env.VITE_SEGMENT_DEBUG === 'true' || true,
  },
} as const;
